import * as React from "react";
import {observer} from "mobx-react";
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import FilledButton from "../../../components/buttons/FilledButton";
import LineButton from "../../../components/buttons/LineButton";

function PossibleDuplicateLeadsDialog({
    possibleDuplicateLeadRows,
    selectedPossibleDuplicateLeadId,
    canNotifyResponsible,
    onSelect,
    onCancel,
    onCreateAnyway,
    onNotifyResponsible,
}) {
    const possibleDuplicateLeadRow = (row) => {
        const isSelected = row.id === selectedPossibleDuplicateLeadId;
        return (
            <Box
                key={row.id}
                onClick={() => onSelect(row.id)}
                sx={{
                    cursor: 'pointer',
                    padding: '0.75rem',
                    border: '1px solid',
                    borderColor: isSelected ? 'primary.main' : 'divider',
                    borderRadius: '0.5rem',
                }}
            >
                <Typography fontWeight={500}>{row.fantasyName}</Typography>
                <Typography variant="body2">Razón social: {row.businessName || '—'}</Typography>
                <Typography variant="body2" color="text.secondary">
                    Etapa: {row.stageLabel} · Canal: {row.commercialChannel} · Responsable: {row.responsible}
                </Typography>
                <Typography variant="body2" color="text.secondary">Creado por: {row.creator}</Typography>
                <Typography variant="body2" color="text.secondary">Coincide por: {row.matchedBy}</Typography>
            </Box>
        );
    };

    return (
        <Dialog open onClose={onCancel} fullWidth maxWidth="sm">
            <DialogTitle>Posible duplicado</DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
                    <Typography>Ya existen leads activos que coinciden con el que querés cargar.</Typography>
                    {possibleDuplicateLeadRows.map(possibleDuplicateLeadRow)}
                </Box>
            </DialogContent>
            <DialogActions>
                <LineButton onClick={onCancel}>Cancelar</LineButton>
                <LineButton disabled={!canNotifyResponsible} onClick={onNotifyResponsible}>
                    Avisar al responsable
                </LineButton>
                <FilledButton onClick={onCreateAnyway}>Crear igual</FilledButton>
            </DialogActions>
        </Dialog>
    );
}

export default observer(PossibleDuplicateLeadsDialog);
